<script>
  import { Container } from 'element-ui'
  export default {
    name:'ElContainer',
    extends:Container
  }
</script>
